import { z } from 'zod';

export const notificationDto = z.object({
  id: z.uuid(),
  kind: z.string(),
  title: z.string(),
  body: z.string().nullable(),
  href: z.string().nullable(),
  actorName: z.string().nullable(),
  read: z.boolean(),
  archived: z.boolean(),
  createdAt: z.string(),
});
export type NotificationDto = z.infer<typeof notificationDto>;

/** Quais avisos também vão por e-mail. */
export const NOTIFICATION_EMAIL_KINDS = {
  'task.assigned': 'Tarefa atribuída a mim',
  'task.due_soon': 'Prazo chegando',
  comment: 'Comentários nas minhas tarefas e arquivos',
  'approval.requested': 'Pedido de aprovação',
  'approval.decided': 'Aprovação respondida',
  request: 'Nova solicitação na Inbox',
  payment: 'Pagamento recebido',
  invoice: 'Nova fatura',
} as const;
export type NotificationEmailKind = keyof typeof NOTIFICATION_EMAIL_KINDS;

export const notificationPrefs = z.object({
  /** Tipos com e-mail desligado (padrão: todos ligados). */
  emailOff: z.array(z.string().max(40)).max(40).default([]),
});
export type NotificationPrefs = z.infer<typeof notificationPrefs>;
